export default __webpack_public_path__ + "static/media/icon-cloud-upload.0cd31743.svg";